(() => {
  if (customElements.get('miresmo-stock-grid')) return;
  class StockGrid extends HTMLElement {
    connectedCallback() {
      // Scripts may run before children are parsed; defer initialization.
      if (this.started) return;
      this.started = true;
      this.timer = setTimeout(() => this.waitForContent(), 0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.contentObserver?.disconnect();
      this.controller?.abort();
      this.started = false;
    }
    waitForContent() {
      if (!this.isConnected) return;
      const ready = () => this.querySelector('hdt-reval-items') &&
        this.querySelector('template[data-stock-pool]')?.content.querySelector('hdt-reval-items') &&
        this.querySelector('[data-stock-status]');
      if (ready()) { this.init(); return; }
      this.contentObserver = new MutationObserver(() => {
        if (ready()) { this.contentObserver.disconnect(); this.init(); }
      });
      this.contentObserver.observe(this, {childList:true, subtree:true});
    }
    init() {
      if (!this.isConnected) return;
      this.grid = this.querySelector('hdt-reval-items');
      this.button = this.querySelector('[data-stock-more]');
      this.status = this.querySelector('[data-stock-status]');
      this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 10);
      this.nextUrl = this.dataset.nextUrl || '';
      this.pool = [];
      this.seen = new Set();
      this.visited = new Set();
      this.loading = false;
      this.needsInitial = true;
      this.controller = new AbortController();
      this.grid?.querySelectorAll('hdt-card-product').forEach(card => this.seen.add(this.key(card)));
      this.collect(this);
      this.button?.addEventListener('click', () => this.load(this.needsInitial), {signal:this.controller.signal});
      this.load(true);
    }
    key(card) {
      return card.dataset.productId || card.querySelector('[data-pr-url]')?.getAttribute('href') || card.outerHTML;
    }
    collect(root) {
      const template = root.querySelector('template[data-stock-pool]');
      if (!template) throw new Error('Lipsește lista de produse.');
      template.content.querySelectorAll('hdt-card-product').forEach(card => {
        if (card.classList.contains('miresmo-collection-card--sold-out') || card.classList.contains('hdt-pr-sold_out')) return;
        const key = this.key(card);
        if (!this.seen.has(key)) {
          this.seen.add(key);
          this.pool.push(card.cloneNode(true));
        }
      });
    }
    async fill(count) {
      while (this.pool.length < count && this.nextUrl) {
        const url = new URL(this.nextUrl, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Adresă de paginare invalidă.');
        // Preserve preview/theme and locale context from the current page.
        const current = new URL(window.location.href);
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key));
        }
        url.searchParams.set('section_id',this.dataset.sectionId);
        if (this.visited.has(url.href)) throw new Error('Paginare repetată.');
        const response = await fetch(url, {credentials:'same-origin', signal:this.controller.signal});
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const incoming = doc.getElementById(this.id);
        if (!incoming) throw new Error('Gridul nu a fost găsit.');
        this.collect(incoming);
        this.visited.add(url.href);
        this.nextUrl = incoming.dataset.nextUrl || '';
      }
    }
    async load(initial) {
      if (this.loading || !this.grid) return;
      this.loading = true;
      if (this.button) this.button.disabled = true;
      this.grid.setAttribute('aria-busy','true');
      this.status.textContent = '';
      try {
        const missing = Math.max(0,this.pageSize-this.grid.querySelectorAll('hdt-card-product').length);
        const count = initial ? missing : this.pageSize;
        // Look ahead one available card to hide the button at the true end.
        await this.fill(count + (this.dataset.loadMore === 'true' ? 1 : 0));
        const cards = this.pool.splice(0,count);
        cards.forEach(card => { card.style.opacity='1'; card.style.transform='none'; this.grid.appendChild(card); });
        this.needsInitial = false;
        this.grid.dispatchEvent(new CustomEvent('products:update',{bubbles:true}));
        if (typeof this.grid.revealInstant === 'function') this.grid.revealInstant();
        if (!this.grid.querySelector('hdt-card-product')) this.status.textContent='Momentan nu există produse disponibile în această colecție.';
        if (this.button) this.button.hidden = this.pool.length === 0 && !this.nextUrl;
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.status.textContent='Produsele nu au putut fi încărcate. Încearcă din nou.';
          if (this.button) this.button.hidden=false;
        }
      } finally {
        this.loading=false;
        if (this.button) this.button.disabled=false;
        this.grid.setAttribute('aria-busy','false');
      }
    }
  }
  customElements.define('miresmo-stock-grid',StockGrid);
})();
